// Horcrux `Remote/Clipboard` registers its Module Federation container as the global `Clipboard`, which collides
// with the browser's native `window.Clipboard` interface: the host's external loader does
// `if (typeof Clipboard !== 'undefined') return resolve()` and never downloads Clipboard@<version>.js
// ("fn is not a function"). Share-scope init touches every remote on first use, so the native constructor must be
// dropped before any remote loads. `navigator.clipboard` is unaffected. Reported to Horcrux owners (unclear #22).
if (typeof window.Clipboard === 'function' && !window.Clipboard.get) delete window.Clipboard;

import('./bootstrap');
